import React, { useState } from "react";
import {
  View,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  TouchableOpacity,
} from "react-native";

import appStyles from "../../../../appStyles";
import { isAppleDevice, isWeb, openURL } from "../../../../../helpers/utils";
import AppConfig from "../../../../../config/AppConfig";

import Header from "../Header";
import IntegrationIcons from "../../../common/icons/integrations";
import GuidesIcon from "../../../common/icons/more/GuidesIcon";
import ImageComponent from "../../../common/ImageComponent";
import ManaIcon from "../../../common/icons/ManaIcon";

import styles from "../integrationStyles";
import IntegrationsHelper from "../../IntegrationsHelper";
import steps from "../steps";
import { INTEGRATION_KEYS } from "../../IntegrationsHelper";
import LoadingIndicator from "../../../common/LoadingIndicator";

export default function HealthIntegration({
  controller,
  isFromCard = false,
  goToStep = () => {},
}) {
  const [isLoading, setIsLoading] = useState(false);

  const connect = () => {
    if (!isAppleDevice) {
      return goToStep(steps.checklist);
    }

    setIsLoading(true);
    IntegrationsHelper.saveIntegrations(
      controller,
      { [INTEGRATION_KEYS.health]: true },
      () => {
        controller.refreshIntegrations(true);
        setIsLoading(false);

        // Show health-added screen
        goToStep(steps.healthAdded);
      },
      () => setIsLoading(false),
    );
  };

  const goBack = () => {
    if (isFromCard || !isWeb) {
      controller.goBack();
    } else {
      goToStep(steps.desktop);
    }
  };

  return (
    <>
      <LoadingIndicator isLoading={isLoading} />

      <Header title="Let’s connect!" controller={controller} goBack={goBack} />

      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        {/* Connect */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>
            Once we connect to Health, we can:
          </Text>

          <View style={styles.row}>
            <IntegrationIcons.NotificationsIcon style={styles.icon} />
            <Text style={styles.rowText}>Automatically track sleep</Text>
          </View>

          <View style={styles.row}>
            <IntegrationIcons.WorkoutsIcon style={styles.icon} />
            <Text style={styles.rowText}>Automatically track workouts</Text>
          </View>

          <View style={styles.row}>
            <GuidesIcon style={styles.icon} width={30} height={30} />
            <Text style={styles.rowText}>
              Provide custom insights to optimize wellness
            </Text>
          </View>
        </View>

        {/* Safety */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Hold on, is this safe?</Text>

          <View style={styles.row}>
            <IntegrationIcons.MetricsIcon style={styles.icon} />

            <Text style={styles.rowText}>
              Choose which metrics to share with us
            </Text>
          </View>
          <View style={styles.row}>
            <IntegrationIcons.PersonalIcon style={styles.icon} />

            <Text style={styles.rowText}>Revoke sharing at any time</Text>
          </View>
          <View style={styles.row}>
            <IntegrationIcons.DollarIcon
              style={styles.icon}
              width={30}
              height={30}
            />

            <Text style={styles.rowText}>
              We’re not in the business of selling your data - that’s a promise
              that sets us apart.
            </Text>
          </View>

          <View style={styles.row}>
            <ManaIcon style={styles.icon} width={30} height={30} />

            <Text
              style={(styles.rowText, styles.link)}
              onPress={() => {
                openURL(AppConfig.PRIVACY_LINK);
              }}
            >
              Tap here for more on privacy at Mana
            </Text>
          </View>
        </View>
      </ScrollView>

      {/* Buttons */}
      <View style={[appStyles.footerButtons, appStyles.verticalFooterButtons]}>
        <TouchableOpacity
          onPress={connect}
          style={[styles.button, { width: 170 }]}
        >
          <ImageComponent
            image={require("../../../../../assets/integrations/health.png")}
            style={styles.buttonIcon}
          />
          <Text style={styles.buttonText}>Connect Health</Text>
        </TouchableOpacity>

        <Text style={styles.skipText} onPress={() => goToStep(steps.checklist)}>
          Skip for now
        </Text>
      </View>
    </>
  );
}
